
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup, List } from 'vant';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
import { userList, userDel, userHelper, getUserType, getBaseinfo } from './api/index';
import ListItem from './components/ListItem.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
Vue.use(Popup).use(Dialog).use(Toast).use(Button).use(List);
import { OPTHINES } from './config';
import { baseinfo } from '@/api/commonApi';
enum EUserStatus {
  'unRegistered' = 201,
  'reviewing' = 202,
  'reviewed' = 203,
}
const map = new Map();
map.set('DEV', 'https://dev.cqcb.com/shangyou_news');
map.set('TEST', 'https://testdev.cqcb.com/shangyou_news');
map.set('production', 'https://wap.cqcb.com/shangyou_news');
map.set('development', 'https://dev.cqcb.com/shangyou_news');
@Component({
  components: {
    ListItem,
  },
})
export default class User extends Vue {
  option = config.OPTHINES;
  userStatus: any = null;
  showModal = false;
  userList: any[] = [];
  createDate: any[] = [];
  showUserList = true;
  pointOut = false;
  loading = false;
  finished = false;
  startTime: any;
  endTime: any;
  nowTime: any;
  downLoadUrl =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  page = 1;

  get source() {
    return this.$route.params.source;
  }
  get msg() {
    if (!window.udid) {
      return '请前往客户端登录查看～';
    } else if (
      window.udid &&
      window.gettoken &&
      window.gettoken() &&
      this.userList.length === 0 &&
      !this.showUserList
    ) {
      return '暂未上传作品，快去上传吧～';
    } else {
      return '请前往客户端登录查看～';
    }
  }
  created() {
    userHelper().then((res) => console.log('访问userHelper'));
    // 分享
    appShare({
      title: OPTHINES.title,
      url: window.location.href,
      subtitle: OPTHINES.subtitle,
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: OPTHINES.title,
      subtitle: OPTHINES.subtitle,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  async onLoad() {
    userList(this.page).then((res: any) => {
      this.successGetUser(res);
    });
    const baseInfo = await getBaseinfo(this.option.voteName);
    this.startTime = baseInfo.data.startTime * 1000;
    this.endTime = baseInfo.data.endTime * 1000;
    this.nowTime = new Date().getTime();
    console.log(this.startTime, this.endTime, this.nowTime);
  }
  public successGetUser(res: any) {
    console.log(res.code);
    switch (res.code) {
      case 100:
        this.showUserList = false;
        // if (!window.udid) {
        if (isWeiXin()) {
          console.log('on weixin page');
        } else if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 200:
        if (this.page === 1 && res.data.length === 0) {
          this.showUserList = false;
        } else {
          console.log('res.data', res.data);
          this.page = this.page + 1;
          if (!res.data || res.data.length === 0) {
            this.finished = true;
          } else {
            this.userList = [...this.userList, ...res.data];
          }
          this.loading = false;
          // 时间格式转换
          for (const timeItem of res.data) {
            const date = new Date();
            date.setTime(timeItem.createtime * 1000);
            // const year = date.getYear();
            const month = date.getMonth() + 1;
            const d = date.getDate();
            this.createDate.push(month + '-' + d);
          }
        }
    }
  }
  public handleDel(id: any) {
    Dialog.confirm({
      title: '提示',
      message: '你确定要删除吗？',
    })
      .then(() => {
        userDel(id).then((res) => this.successDelete(res));
      })
      .catch(() => {
        console.log('取消删除');
      });
  }
  // 删除成功
  public successDelete(res: any) {
    if (res.code === 200) {
      Toast('删除成功！');
      setTimeout(() => {
        this.$router.go(0);
      }, 1000);
    }
  }
  public enterUploading() {
    if (this.nowTime < this.startTime) {
      Toast('活动未开始');
      return false;
    } else if (this.nowTime > this.endTime) {
      Toast('活动已结束');
      return false;
    }
    if (window.gettoken() && window.gettoken() !== 'null') {
      // 判断该作文用户状态
      getUserType().then((res) => this.enterUserType(res));
    } else if (!window.udid) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else if (window.udid) {
      // 用户未登录
      // console.log('用户未登录', getClientInfo(), window.version);
      if (parseFloat(window.version) >= 4.5) {
        const option = {
          action: 'mUserLogin',
          data: '请先登录上游账号',
        };
        window.handleMessage(JSON.stringify(option));
      } else {
        window.location.href = 'client:logout';
      }
    } else {
      window.location.href = `${map.get(
        process.env.VUE_APP_ENV_NAME,
      )}/composition/contribute`;
    }
  }
  public enterUserType(res: any) {
    console.log('res.statusCode', res.statusCode);
    this.userStatus = Number(res.statusCode);
    console.log(process.env.ENV_NAME);

    const JUMP_URL = map.get(process.env.VUE_APP_ENV_NAME);

    if (this.userStatus === EUserStatus.unRegistered) {
      // 未注册作文用户前往作文注册页面
      console.log('不是作文用户');
      Toast('请完善作文用户资料');
      setTimeout(() => {
        window.location.href = `${JUMP_URL}/composition/UserCenter`;
      }, 200);
    } else if (this.userStatus === EUserStatus.reviewing) {
      // 审核状态弹窗提示账户审核中，无法上传作文
      this.toggleDialog();
    } else if (this.userStatus === EUserStatus.reviewed) {
      // 账号审核通过，跳转至发布作文页面
      console.log('是作文用户');
      window.location.href = `${JUMP_URL}/composition/contribute`;
    }
  }
  public toggleDialog() {
    this.showModal = !this.showModal;
  }
}
